"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MarketplaceBar = /** @class */ (function (_super) {
    __extends(MarketplaceBar, _super);
    function MarketplaceBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketplaceBar.prototype.render = function () {
        var url = "https://www.aperza.com/corp/contact/aperza";
        return (react_1.default.createElement("div", { className: "marketplace-bar" },
            react_1.default.createElement("img", { className: "marketplace-bar-img", useMap: "#marketplacemap", src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" }),
            react_1.default.createElement("map", { name: "marketplacemap" },
                react_1.default.createElement("area", { shape: "rect", coords: "914,16,962,30", href: url, target: "_blank" }))));
    };
    return MarketplaceBar;
}(react_1.default.Component));
exports.default = MarketplaceBar;
